import InnerTabs, { TabT } from 'components/Tabs/InnerTabs'
import { buildTranslate } from 'locales'
import React from 'react'
import { useOnboardingSlideshow } from './OnboardingSlideshow/hooks'
import SignupMessage from './SignupMessage'

export enum Tabs {
  OnboardingSlideshowContent = 'onboarding_slideshow_content',
  OnboardingSlideshowStyle = 'onboarding_slideshow_style',
  SignupMessage = 'signup_message',
}

const t = buildTranslate('cms')

const Signup = () => {
  const { tab: slideshowTab } = useOnboardingSlideshow()
  const tabs: Array<TabT> = [
    slideshowTab,
    {
      key: Tabs.SignupMessage,
      component: <SignupMessage />,
      title: t('signup.signup_message.title'),
    },
  ]

  return <InnerTabs tabs={tabs} />
}

export default Signup
